import {
  type FeedbackOptionCategory,
  OrderListFeedbackContextProvider,
  type UserData,
} from "~/features/orders/orderDetails/hooks/useSendOrderFeedback/components/OrderListFeedbackContext";
import { OrderListPage } from "~/features/orders/orderList/OrderListPage";
import {
  type MultiAccountAccountData,
  MultiAccountSearchDataProvider,
} from "~/features/orders/orderList/components/OrderListSearchBox/MultiAccountSelect/MultiAccountSearchDataProvider";
import { OrderListDesignToggleProvider } from "../common/components/NewDesignToggle";

export interface OrderHistoryAccountsData {
  accounts: MultiAccountAccountData[];
}

export interface OrderHistoryFilters {
  salesDocument?: string;
  customerOrderId?: string;
  partNumber?: string;
  customerMatnr?: string;
  matnr?: string;
  selectedAccounts?: string[];
  sdCreationStart?: string;
  sdCreationEnd?: string;
}

export interface OrderHistoryPageProps {
  userData: UserData;
  orderFeedbackOptions: FeedbackOptionCategory[];
  accounts?: OrderHistoryAccountsData;
  filters?: OrderHistoryFilters;
}

export function create(data: OrderHistoryPageProps) {
  return (
    <OrderListFeedbackContextProvider
      value={{ userData: data.userData, orderFeedbackOptions: data.orderFeedbackOptions }}
    >
      {/*
        TODO(0145): MultiAccountSearchDataProvider is shared with the still-unmigrated
        QuoteList and Orderbook factories, which pass a JSON string. Re-stringify here
        until those migrate and the provider is switched to typed data.
      */}
      <MultiAccountSearchDataProvider accountsJson={data.accounts ? JSON.stringify(data.accounts) : undefined}>
        <OrderListDesignToggleProvider>
          <OrderListPage />
        </OrderListDesignToggleProvider>
      </MultiAccountSearchDataProvider>
    </OrderListFeedbackContextProvider>
  );
}
